export default __webpack_public_path__ + "static/ios15_cover-f5b7b8bf2018ac66ccf67b0cd613ef75.png";